import endPoints from "services/endPoints"
import fileUploadApi from "services/fileUploadApi"
import getApi from "services/getApi"
import postApi from "services/postApi"
import putApi from "services/putApi"
import { showToastAction } from "store/slices/commonSlice"
import { setUserProfile } from "store/slices/userSlice"

const getProfileAction = (dispatch, onRes) => async () => {
    const res = await getApi(endPoints.MY_PROFILE)
    if (res.success) {
        onRes && onRes(res?.data)
        dispatch(setUserProfile(res?.data))
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message
        }))
    }
}

const uploadProfilePicture = (file, dispatch, onRes) => async () => {
    const res = await fileUploadApi(endPoints.SINGLE_FILE_UPL, { file: file })
    if (res.success) {
        onRes(res?.data)
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message
        }))
    }
}

const updateProfileAction = (data, links, setLoading, dispatch, navigate, onRes) => async () => {
    setLoading(true)

    let imgPath = ""
    if (data?.profilePicture) {
        if (typeof data?.profilePicture == "object") {
            await dispatch(uploadProfilePicture(data?.profilePicture, dispatch, (imgRes) => {
                imgPath = imgRes?.path
            }))
        } else {
            imgPath = data?.profilePicture
        }
    }

    const payload = {
        fullName: data?.fullName,
        category: data?.category,
        label: data?.distributor,
        publisher: data?.publisher,
        about: data?.aboutMe,
    }

    if (imgPath) {
        payload.image = imgPath
    }

    if (links.length) {
        payload.socials = links.map((item) => {
            return {
                type: item?.type,
                id: item?.id || null,
                link: item.link,
            }
        })
    } else {
        payload.socials = []
    }

    const res = await putApi(endPoints.PROFILE_UPDATE, payload)

    if (res.success) {
        dispatch(showToastAction({
            type: "success",
            detail: res?.message
        }))
        onRes && onRes(res?.data)
        dispatch(setUserProfile(res?.data))
        navigate("/profile")
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: res?.message
        }))
    }
    setLoading(false)
}

export {
    getProfileAction,
    updateProfileAction,
    uploadProfilePicture
}